<template>
    <v-container>
        <v-form ref="form" @submit.prevent="saveQuestion" class="custom_form">
            <v-card>
                <v-dialog
                    persistent
                    v-model="editTextDialog"
                    width="900"
                    height="800"
                >
                    <EditText
                        :editedText="toBeEditedText"
                        @changeEditedText="changeEditedText($event)"
                    />
                </v-dialog>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5"> Statement </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="question.questionStatement"
                                outlined
                                dense
                                clearable
                                @click="editTextStatement($event)"
                                :rules="questionStatementRules"
                                :success="questionStatementSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5">
                                Key Sequence
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <div style="width:500">
                                <template
                                    v-for="(itm,
                                    indx) in question.questionKeySequence"
                                >
                                    <v-chip
                                        :key="indx"
                                        close
                                        @click:close="deleteKey(indx)"
                                    >
                                        {{ itm }}
                                    </v-chip>
                                </template>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-card style="width:150px" class="ml-5">
                            <ul
                                style="text-decoration:none"
                                v-for="(key, i) in keySequenceMaster4"
                                :key="i"
                            >
                                <v-row>
                                    <v-col
                                        cols="5"
                                        style="font-size:15px"
                                        no-gutters
                                        class="ma-0 pa-0"
                                    >
                                        {{ key }}
                                    </v-col>
                                    <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"
                                        ><v-icon
                                            style="font-size:15px"
                                            no-gutters
                                            @click="addKey4(i)"
                                            >mdi-plus</v-icon
                                        >
                                    </v-col>
                                </v-row>
                            </ul>
                        </v-card>
                        <v-card style="width:150px" class="ml-5">
                            <ul
                                style="text-decoration:none"
                                v-for="(key, i) in keySequenceMaster5"
                                :key="i"
                            >
                                <v-row>
                                    <v-col
                                        cols="5"
                                        style="font-size:15px"
                                        class="ma-0 pa-0"
                                    >
                                        {{ key }}
                                    </v-col>
                                    <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"
                                        ><v-icon
                                            style="font-size:15px"
                                            @click="addKey5(i)"
                                            >mdi-plus</v-icon
                                        >
                                    </v-col>
                                </v-row>
                            </ul>
                        </v-card>

                        <v-card style="width:150px" class="ml-5">
                            <ul
                                style="text-decoration:none"
                                v-for="(key, i) in keySequenceMaster6"
                                :key="i"
                            >
                                <v-row>
                                    <v-col
                                        cols="5"
                                        style="font-size:15px"
                                        class="ma-0 pa-0"
                                    >
                                        {{ key }}
                                    </v-col>
                                    <v-col cols="1" class="ml-0 pl-0 ma-0 pa-0"
                                        ><v-icon
                                            style="font-size:15px"
                                            @click="addKey6(i)"
                                            >mdi-plus</v-icon
                                        >
                                    </v-col>
                                </v-row>
                            </ul>
                        </v-card>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5">
                                Select Options
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-combobox
                                v-model="question.questionOptions"
                                :items="thaats"
                                :search-input.sync="searchOption"
                                hide-selected
                                hint="Maximum of 10 tags"
                                label="Add some tags"
                                multiple
                                persistent-hint
                                small-chips
                                deletable-chips
                                append-outer-button
                                :success="questionOptionsSuccess"
                                :rules="questionOptionsRules"
                            >
                                <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                No results matching "<strong>{{
                                                    searchOption
                                                }}</strong
                                                >". Press <kbd>enter</kbd> to
                                                create a new one
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-combobox>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5">
                                Select Answers
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-combobox
                                v-model="questionAns"
                                :items="question.questionOptions"
                                :search-input.sync="searchAnswer"
                                hide-selected
                                hint="Maximum of 10 tags"
                                label="Add some tags"
                                multiple
                                persistent-hint
                                small-chips
                                deletable-chips
                                :success="questionAnswersSuccess"
                                :rules="questionAnswersRules"
                            >
                                <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                No results matching "<strong>{{
                                                    searchAnswer
                                                }}</strong
                                                >". Press <kbd>enter</kbd> to
                                                create a new one
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-combobox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-4">
                        <v-col cols="2" align="right" class="mr-3 mt-2">
                            <v-card-text class="pr-5"> Audio </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-badge
                                right
                                top
                                avatar
                                overlap
                                color="blue"
                                class="for_custom-badge"
                            >
                                <template v-slot:badge>
                                    <v-avatar size="36" align="left">
                                        <v-file-input
                                            accept="audio/*"
                                            prepend-icon="mdi-pencil-outline"
                                            label="questionAudio"
                                            ref="fileAudio"
                                            hide-input
                                            dense
                                            :rules="questionAudioRules"
                                            :success="questionAudioSuccess"
                                            @change="onAudioFileSelected()"
                                        >
                                        </v-file-input>
                                    </v-avatar>
                                </template>
                                <audio
                                    ref="audioElm"
                                    :src="questionAud"
                                    controls
                                    max-height="50"
                                    min-height="50"
                                    max-width="150"
                                    min-width="150"
                                    contain
                                    elevation
                                ></audio>
                            </v-badge>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <v-card-text class="pr-5">
                                Question Status
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="question.questionStatus"
                                inset
                                dense
                                class="mt-2"
                                color="blue"
                                :label="
                                    question.questionStatus
                                        ? 'Active'
                                        : 'Inactive'
                                "
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row v-if="errorMessage || successMessage">
                        <v-col cols="6" offset-md="2">
                            <v-alert v-if="errorMessage" type="error">
                                {{ errorMessage }}
                            </v-alert>
                            <v-alert v-if="successMessage" type="success">
                                {{ successMessage }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)"
                                    >cancel</v-btn
                                >
                                <v-btn
                                    class="mx-5"
                                    :disabled="disabled"
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="saveQuestion"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import TypeTwoQuestion from "../../models/TypeTwoQuestion";
import EditText from "../../components/admin/EditText";
import Thaat from "../../models/Thaat";
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) {
                    vm.$router.push("/");
                }
            }, 0);
        });
    },
    name: "AddTypeTwoQuestion",
    components: {
        EditText
    },
    data() {
        return {
            question: new TypeTwoQuestion(),
            items: [],
            thaats: [
                // "Bilawal","Khamaaj","Kaafi","Asavari","Bahiravi",
                // "Kalyan","Marwa","Purvi","Todi","Bhairav"
            ],
            successMessage: "",
            search: "",
            searchOption: null,
            searchAnswer: null,
            questionOptions: "",
            questionAnswers: "",
            questionAns: [],
            errorMessage: "",
            disabled: false,
            questionAud: "",
            file: "",
            toBeEditedText: "",
            inputType: "",
            textField: null,
            editTextDialog: false,
            keySequenceMaster4: [
                "4C",
                "4C#",
                "4D",
                "4D#",
                "4E",
                "4F",
                "4F#",
                "4G",
                "4G#",
                "4A",
                "4A#",
                "4B"
            ],

            keySequenceMaster5: [
                "5C",
                "5C#",
                "5D",
                "5D#",
                "5E",
                "5F",
                "5F#",
                "5G",
                "5G#",
                "5A",
                "5A#",
                "5B"
            ],

            keySequenceMaster6: [
                "6C",
                "6C#",
                "6D",
                "6D#",
                "6E",
                "6F",
                "6F#",
                "6G",
                "6G#",
                "6A",
                "6A#",
                "6B"
            ],
            questionKeySequence: [],

            /* questionTitleSuccess: false,
                questionTitleRules: [
                v => {
                    if (v)
                    {
                        this.questionTitleSuccess = true;
                        return true;
                    } else {
                        this.questionTitleSuccess= false;
                        return "Title is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Title must be at least 2 characters long",
                v =>
                    (v || "").length <= 30 ||
                    "Title must be less than 30 characters"
            ],
        /*
            questionDescriptionSuccess:false,
            questionDescriptionRules: [
                v => {
                    if (v) {
                        this.questionDescriptionSuccess = true;
                        return true;
                    } else {
                        return "Description is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Description be at least 2 characters long",
                v =>
                    (v || "").length <= 1000 ||
                    "Description must be less than 1000 characters"
            ],
            */
            questionStatementSuccess: false,
            questionStatementRules: [
                v => {
                    if (v) {
                        this.questionStatementSuccess = true;
                        return true;
                    } else {
                        this.questionStatementSuccess = false;
                        return "Statement is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "Statement be at least 2 characters long",
                v =>
                    (v || "").length <= 255 ||
                    "Statement must be less than 255 characters"
            ],

            questionOptionsSuccess: false,
            questionOptionsRules: [
                v =>
                    (v || []).length >= 1 ||
                    "Question options must contain at least one value",
                v =>
                    (v || []).length <= 10 ||
                    "Question options must contain at most ten values"
            ],

            questionAnswersSuccess: false,
            questionAnswersRules: [
                v =>
                    (v || []).length >= 1 ||
                    "Question options must contain at least one value",
                v =>
                    (v || []).length <= 10 ||
                    "Question options must contain at most ten values"
            ],

            questionAudioSuccess: false,
            questionAudioRules: [
                // v =>
                //     (!v || v.size<1000000) ||"Question audio size should be less than 1MB",
            ]
        };
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods: {
        onAudioFileSelected() {
            {
                this.file = event.target.files[0];
                var reader = new FileReader();
                var vm = this;
                reader.onload = e => {
                    vm.questionAud = e.target.result;
                };
                reader.readAsDataURL(this.file);
                this.question.questionAudio = this.file;
                //this.lesson.lessonImage=event.target.result;//URL.createObjectURL(event.target.files[0]);
                //console.log('this.on audio file selected', this.question.questionAudio, 'event.tagetfiles', event.target.files[0]);
            }
        },

        saveQuestion() {
            this.disabled = true;
            //  if (this.question.questionTitle.length<2 ||this.question.questionTitle.length>30)
            //  {
            //     this.errorMessage = 'Title should be valid';
            //     setTimeout(() => (this.errorMessage = ""), 5000);
            //     this.disabled = false;
            //     return;
            //  }
            //  if (this.question.questionDescription.length<2 || this.question.questionDescription.length>1000)
            //  {
            //     this.errorMessage = 'Description should be valid';
            //     setTimeout(() => (this.errorMessage = ""), 5000);
            //     this.disabled = false;
            //     return;
            //  }

            // if (this.question.questionStatement&&(this.question.questionStatement.length<2 || this.question.questionStatement.length>500))
            if (
                this.question.questionStatement.length < 2 ||
                this.question.questionStatement.length > 255
            ) {
                this.errorMessage = "Statement should be valid";
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (
                this.question.questionOptions.length < 1 ||
                this.question.questionOptions.length > 10
            ) {
                this.errorMessage = "Question options should be valid";
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            this.question.questionAnswers = this.questionAns;
            if (
                this.question.questionAnswers.length < 1 ||
                this.question.questionAnswers.length > 10
            ) {
                this.errorMessage = "Question Answers should be valid";
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (
                !this.question.questionAnswers.every(val =>
                    this.question.questionOptions.includes(val)
                )
            ) {
                this.errorMessage =
                    "Question Answers should be within question options";
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            /*if (this.question.questionAudio&&this.question.questionAudio.size>1000000)
                {
                    this.errorMessage = 'Audio should be valid';
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                    return;
                }*/

            //console.log('question key seq outside', this.question.questionKeySequence);
            // if (this.question.questionKeySequence.length===0)
            // {
            //     //console.log('question key seq inside ', this.question.questionKeySequence);
            //     this.errorMessage = 'Key sequence should be valid';
            //     setTimeout(() => (this.errorMessage = ""), 5000);
            //     this.disabled = false;
            //     return;
            // }

            if (!this.question.questionStatus) {
                this.question.questionStatus = false;
            }

            if (
                !(this.question.questionStatus === true) &&
                !(this.question.questionStatus === false)
            ) {
                //console.log('question status inside', this.question.questionStatus);
                this.errorMessage = "Status should be valid";
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }
            console.log("question options", this.question.questionOptions);

            // this.questionOptions=JSON.stringify(this.question.questionOptions)
            // this.questionAnswers=JSON.stringify(this.question.questionAnswers)
            // this.questionKeySequence=JSON.stringify(this.question.questionKeySequence)
            // const formData=new FormData();
            //formData.append('questionTitle', this.question.questionTitle);
            // formData.append('questionDescription', this.question.questionDescription);
            // formData.append('questionImage', this.question.questionImage);
            // formData.append('questionAudio', this.question.questionAudio);
            // formData.append('questionStatement', this.question.questionStatement);
            // formData.append('questionOptions', this.questionOptions);
            // formData.append('questionAnswers', this.questionAnswers);
            // formData.append('questionStatus', this.question.questionStatus);
            // formData.append('questionKeySequence', this.questionKeySequence);
            const formData = {
                questionAudio: this.question.questionAudio,
                questionStatement: this.question.questionStatement,
                questionKeySequence: this.question.questionKeySequence,
                questionStatus: this.question.questionStatus,
                questionOptions: this.question.questionOptions,
                questionAnswers: this.question.questionAnswers
            };
            //console.log('client side method', formData);

            TypeTwoQuestion.postQuestion(this.auth.token, formData)
                .then(res => {
                    this.disabled = false;
                    console.log("res", res);
                    this.successMessage = "Question added successfully";
                    setTimeout(() => (this.successMessage = ""), 5000);
                    this.$refs.form.reset();
                    this.questionAud = "";
                    this.question.questionKeySequence = [];
                    this.question.questionStatus = false;
                })
                .catch(err => {
                    this.errorMessage = err.response.data;
                    this.question.questionStatus = false;
                    this.questionAud = "";
                    this.question.questionKeySequence = [];
                    setTimeout(() => (this.errorMessage = ""), 5000);
                    this.disabled = false;
                });
        },

        addKey4(index) {
            this.question.questionKeySequence.push(
                this.keySequenceMaster4[index]
            );
        },

        addKey5(index) {
            this.question.questionKeySequence.push(
                this.keySequenceMaster5[index]
            );
        },

        addKey6(index) {
            this.question.questionKeySequence.push(
                this.keySequenceMaster6[index]
            );
        },

        deleteKey(index) {
            this.question.questionKeySequence.splice(index, 1);
        },
        clearForm() {
            this.$refs.form.resetValidation();
        },

        editTextStatement(e) {
            this.textField = e.target;
            this.textField.blur();
            this.inputType = "statement";
            this.toBeEditedText = this.question.questionStatement;
            this.editTextDialog = true;
        },

        changeEditedText(editedText) {
            if (editedText === null) {
                this.editTextDialog = false;
            } else {
                //console.log("Selected: "+ this.inputType );
                this.toBeEditedText = editedText;
                if (this.inputType == "statement") {
                    this.question.questionStatement = editedText;
                }
            }
            this.editTextDialog = false;
        },

        getThaats() {
            Thaat.getThaats(this.auth.token)
                .then(res => {
                    this.thaats = res.data.thaatMaster;
                    console.log("this.thaatmaster", this.thaat.thaatMaster);
                })
                .catch(err => console.error(err));
        }
    },
    watch: {
        questionAns(value) {
            console.log("value watch", value);
            if (
                !value.every(el => this.question.questionOptions.includes(el))
            ) {
                this.questionAns.pop();
            }
        }
    },
    mounted() {
        this.getThaats();
    }
    // watch:{
    //     questionOptions (val) {
    //         if (val.length > 5) {
    //             this.$nextTick(() => this.model.pop())
    //     }
    //   },
    //}
};
</script>

<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
.custom_form >>> .v-card__text {
    padding: 10px 16px;
}
.custom_form >>> .v-badge__badge.blue {
    height: 30px;
    min-width: 30px;
    border-radius: 50px;
}
.custom_form >>> .mdi-pencil-outline::before {
    font-size: 18px;
}
.custom_form >>> .v-input__append-outer,
.custom_form >>> .v-input__prepend-outer {
    margin-top: 9px;
}
</style>
